module.exports = __webpack_public_path__ + "img/top_bg.d802cde6.png";